import * as React from 'react';

import {Avatar} from 'shells/avatar/avatar';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';
import {Body} from 'shells/typography/body';

type Props = {
    userName: string | null | undefined;
    userAvatarUrl: string | null | undefined;
    userInitials: string | null | undefined;
    uploadedTime: number | null | undefined;
};

export function AttachmentRowReadState(props: Props) {
    return (
        <div className='flex gap-4 align-start'>
            {props.userName && (
                <StackLegacy isHorizontal={true} spacing={4}>
                    <Avatar
                        size={18}
                        avatarUrl={props.userAvatarUrl}
                        initials={props.userInitials}
                        type='users'
                    />
                    <Body size='small'>{props.userName}</Body>
                </StackLegacy>
            )}

            {props.uploadedTime && (
                <div className='ml-8'>
                    <Body size='small' color='placeholder'>
                        <FormattedTimestamp
                            format={FormattedTimestamp.formats.monthDayYear}
                            datetime={props.uploadedTime}
                            isInline={true}
                        />
                    </Body>
                </div>
            )}
        </div>
    );
}
